// extracted by mini-css-extract-plugin
export default {"container":"tq-z","ratingLayout":"uq-z","ratingLabel":"vq-z","nonInteractiveRatingLabel":"wq-z"};